
































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class ElColor extends Vue {
	@Prop({ type: String, default: "mini" }) size!: string;
	@Prop({ type: String }) value!: string;
	@Prop({
		type: Array,
		default() {
			return [];
		}
	})
	preset!: Array<string>;

	colorUi: string = (this.value || "000").replace(/#/g, "");
	colorUser: string = (this.value || "000").replace(/#/g, "");
	colorPreset: Array<string> = [
		"62c553",
		"33c572",
		"4da9e0",
		"4f7de0",
		"995adf",
		"000",
		"de993e",
		"febb32",
		"e87e2f",
		"f65a41",
		"ef3d39",
		"c0c0c0"
	];
	colorPresetVisible: boolean = false;

	get isMini() {
		return !!/^(mini)$/i.test(this.size);
	}
	get ColorPresetArray() {
		return (this.preset.length ? this.preset : this.colorPreset).map(
			item => {
				return String(item).replace(/#/g, "");
			}
		);
	}

	@Watch("value")
	onColorWatch(val: string) {
		this.colorUi = (val || "000").replace(/#/g, "");
	}

	emit() {
		this.colorPresetVisible = false;
		this.$nextTick(() => {
			const color = "#" + String(this.colorUser).replace(/#/g, "");
			this.$emit("input", color);
		});
	}
}
